import React from 'react'
import RuleList from '../RuleList/RuleList'
import InlineErrorBanner from '../InlineErrorBanner/InlineErrorBanner'
import panelStyles from '../RuleList/RuleList.module.scss'

export const Updates = ({
	rules,
	toggleRule,
	togglingCode,
	prefsBusy,
	prefsLoadStatus,
	prefsError,
	loadPreferences,
	dismissPrefsError,
}) => {
	const isRetrying = prefsLoadStatus === 'loading'

	return (
		<section className={panelStyles.panel}>
			<div className={panelStyles.panel__head}>
				<div>
					<h2 className={panelStyles.panel__title}>Configured updates</h2>
					<p className={panelStyles.panel__description}>
						Enable or pause parent email updates for all of your students.
					</p>
				</div>
			</div>
			{prefsLoadStatus === 'loading' && !prefsError ? (
				<p className={panelStyles.panel__description}>Loading updates…</p>
			) : null}
			{prefsError ? (
				<InlineErrorBanner
					message={prefsError}
					onClose={dismissPrefsError}
					onRetry={loadPreferences}
					retrying={isRetrying}
				/>
			) : null}
			{prefsLoadStatus === 'success' && rules.length === 0 ? (
				<p className={panelStyles.panel__description}>
					No parent notification types are configured yet.
				</p>
			) : null}
			{rules.length > 0 ? (
				<RuleList
					rules={rules}
					onToggleRule={toggleRule}
					togglingCode={togglingCode}
					prefsBusy={prefsBusy}
				/>
			) : null}
		</section>
	)
}

export default Updates
